import { useTheme } from '@mui/material';
import { GridToolbarQuickFilter } from '@mui/x-data-grid';

const SearchBarDataGrid: React.FC = () => {
  const theme = useTheme();
  return (
    <GridToolbarQuickFilter
      sx={{
        width: '100%',
        maxWidth: '38rem',
        bgcolor: theme.colors.canopy.grey[25],
        border: `1px solid ${theme.colors.canopy.grey[200]}`,
        borderRadius: '0.5rem',
        p: '0.63rem 1rem 0.63rem 0.69rem',
        '& .MuiInputBase-root:before': {
          borderBottom: 'none', // Remove the search bar underline when not focused
        },
        '& .MuiInputBase-root:after': {
          borderColor: theme.colors.canopy.primary.main, // Change the color of the search bar underline when focused
        },
        '& .MuiInputBase-root .MuiIconButton-root': {
          color: theme.colors.canopy.content.primary, // Change the color of the clear form 'X' icon
        },
      }}
    />
  );
};

export default SearchBarDataGrid;
